module.exports = __webpack_public_path__ + "static/OR3s-3b5596c152cad0b0dfb18651f7cebe2d.jpg";